import styled from "@emotion/styled";

export const ProgressBarWithLabelContainer = styled.div<{ isOverFilled: boolean }>(({ theme, isOverFilled }) => ({
	display: "flex",
	alignItems: "center",
	gap: 8,
	width: "100%",
	textWrap: "nowrap",
	div: {
		...theme.project.typography.body.body2,
		fontWeight: 500,
		color: isOverFilled ? theme.project.colors.semanticColors.error : theme.project.colors.primaryColors.main
	},
	"& .MuiLinearProgress-root": {
		width: "100%",
		backgroundColor: isOverFilled
			? theme.project.colors.semanticColors.error
			: theme.project.colors.backgroundColors.progressBar
	},
	"& .MuiLinearProgress-bar": {
		backgroundColor: isOverFilled
			? theme.project.colors.semanticColors.error
			: theme.project.colors.primaryColors.main
	}
}));
